<script setup>
import { useRoute } from '@js/utils/route';
import { ref } from 'vue';

const { googleAdsAudience, tenant } = defineProps({
    googleAdsAudience: {
        type: Object,
        required: true,
    },
    tenant: {
        type: Object,
        required: true,
    },
});

const { route } = useRoute();

const loading = ref(false);

function action() {
    loading.value = true;

    axios
        .post(
            route('front.projectManagement.sea.postExportCustomers', {
                tenant: tenant.id,
                googleAdsAudienceId: googleAdsAudience.id,
            }),
            {},
            { responseType: 'blob' },
        )
        .then((response) => {
            const contentDisposition = response.headers['content-disposition'];

            if (contentDisposition != null) {
                let filename = contentDisposition
                    .split(';')[1]
                    .split('=')[1]
                    .replace('"', '')
                    .replace('"', '');
                filename = decodeURI(filename);

                const url = window.URL.createObjectURL(
                    new Blob([response.data]),
                );
                const link = document.createElement('a');

                link.href = url;
                link.setAttribute('download', filename);

                document.body.appendChild(link);
                link.click();

                window.URL.revokeObjectURL(url);
                link.remove();
            }
        })
        .catch((error) => {
            console.log(error);
        })
        .finally(() => {
            loading.value = false;
        });
}
</script>

<template>
    <slot name="button" :action="action" :loading="loading" />
</template>
